import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  MdoBasketCheckedFileToken,
  MdoBasketUploadCheckResponse,
  UploadBasket,
  UploadSDOBasketResponse,
} from '../models';
import { BASKET_API_TOKEN, BASKET_V1_API_TOKEN } from '../tokens';

@Injectable()
export class BasketUploadService {
  constructor(
    private httpClient: HttpClient,
    @Inject(BASKET_API_TOKEN) private url: string,
    @Inject(BASKET_V1_API_TOKEN) private basketV1Url: string,
  ) {
    if (!url) throw new Error('BASKET_API token not provided');
  }

  public uploadSDOBasket(
    accountId: string,
    basket: UploadBasket,
    addToExistingBasket: boolean,
  ) {
    return this.httpClient.post<UploadSDOBasketResponse>(
      `${this.url}/import/${accountId}?${
        addToExistingBasket ? 'addToExistingBasket=true' : ''
      }`,
      basket,
    );
  }

  public checkMdoBasketUpload(accountId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.httpClient.post<MdoBasketUploadCheckResponse>(
      `${this.basketV1Url}/mdo/validate?accountId=${accountId}`,
      formData,
    );
  }

  public importMdoBasket(
    accountId: string,
    fileToken: MdoBasketCheckedFileToken,
    skipErrors = false,
    addToExistingBasket = false,
  ) {
    return this.httpClient.post<string>(
      `${this.basketV1Url}/mdo/import?accountId=${accountId}${
        skipErrors ? '&skipErrors=true' : ''
      }${addToExistingBasket ? '&addToExistingBasket=true' : ''}`,
      {
        fileToken,
      },
    );
  }
}
